export default __webpack_public_path__ + "static/media/Diwali stalls.a5586769.jpg";